module.exports = __webpack_public_path__ + "static/media/intersection_primary.f0bfe26a.svg";